import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TableroTurnosComponent } from '../tablero-turnos/tablero-turnos.component';

const routes: Routes = [
    {
        path: '', component: TableroTurnosComponent,
    
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class TableroTurnosRouting { }
